import React from 'react';
import { Title } from 'components/commons';
import PartnersList from 'components/partners-list';
import { PartnersListMode } from 'components/partners-list/partners-list.utils';
import { getPartners } from 'utils/utils';
import alertIcon from 'assets/svg/alert.svg';

type PartnersListProps = {
    showArrows: boolean;
    mode: PartnersListMode;
}
type RequestDeniedLayoutPartnersProps = {
    screenProfile?: 'default' | 'partners';
    partnersListProps?: PartnersListProps;
}
const RequestDeniedLayoutPartners: React.FC<RequestDeniedLayoutPartnersProps> = ({ screenProfile = 'default', partnersListProps }) => (
    <div className="message-box-container denied-container">
        <div className="inner">
            <div className="screen">
                <div className="message-box">
                    <img className="icon" src={alertIcon} />
                    <Title>talvez mais a frente</Title>
                    <p className="text">
                        Neste momento não será possível <br className="d-block d-sm-none" />
                        realizar o empréstimo por conta <br className="d-block d-sm-none" />
                        do perfil de crédito da sua empresa.
                    </p>
                    <p className="text bold">
                        você receberá um email com <br className="d-block d-sm-none" />
                        a explicação detalhada e <br className="d-block d-sm-none" />
                        dicas para melhorar!
                    </p>
                </div>
                {screenProfile !== 'partners' && <PartnersList
                    header={() => (
                        <>
                            <hr />
                            <p>Temos alguns parceiros de crédito que podem te atender.</p>
                        </>
                    )}
                    partners={getPartners()}
                    {...partnersListProps}
                />}
            </div>
        </div>
    </div>
);
export default RequestDeniedLayoutPartners;
